import { Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import TopicDetails from "./TopicDetails";

export default function TopicsList({ topics }) {
    const [visibleTopics, setVisibleTopics] = useState([])

    useEffect(() => {
        console.log(topics)
        if (topics && topics.length) {
            setVisibleTopics(topics.filter(topic => topic.status.toUpperCase() === 'Y'))
        }
    }, [topics])

    return (
        <Box
            width={['100%', '100%', '100%', '47.5%', '47.5%']}
            bg='#ffffff'
            height={['250px', '300px', '350px', '95%', '95%']}
            borderRadius='10px'
            py='1rem'
            boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
        >
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                mb='2'
                px='1.5rem'
            >
                <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize={['18px', '18px', '22px', '24px', '26px']}
                    fontWeight='900'
                    color='#000000'
                >
                    Topics
                </Text>

            </Box>
            <Box
                width='100%'
                height='5px'
                bg='#fd5f3a'
            ></Box>
            <Box
                width='100%'
                overflowY='auto'
                d='flex'
                flexDir='column'
                height={['75%', '80%', '80%', '80%', '85%']}
                sx={{
                    '&::-webkit-scrollbar': {
                        width: '10px',
                        borderRadius: '8px',
                        backgroundColor: `transparent`,
                        height: '90%',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: `rgba(255, 255, 255,0.2)`,
                        borderRadius: '20px'
                    },
                }}
            >
                {
                    visibleTopics?.length > 0 ?
                        visibleTopics.map(topic => <TopicDetails
                            key={topic.id}
                            id={topic.id}
                            image={topic.cover_image}
                            title={topic.title}
                            files={topic.files}
                            quizzes={topic.quiz_count}
                            status={topic.topic_completed_status}
                        />) :
                        <Text
                            fontWeight='500'
                            fontSize={['10px', '14px', '16px', '16px']}
                            color='#333333'
                            textAlign = 'center'
                            mt = '2'
                        >
                            No topics to display!
                        </Text>
                }
            </Box>
        </Box>
    )
}